import { globalOptions } from 'Dictionaries/imports/importOptionsDictionary.js';
export const options = _.merge(
    {
        identifiers: {
            company: {
                title: window.i18n.__('Critère de comparaison pour les sociétés'),
                choices: [
                    {
                        value: 'company_id',
                        label: window.i18n.__('Identifiant société'),
                        description: window.i18n.__('Récupéré uniquement depuis un export Sellsy.'),
                    },
                    {
                        value: 'company_reference',
                        label: window.i18n.__('Référence'),
                        description: window.i18n.__(
                            'Référence de la société affichée sur la fiche société.',
                        ),
                    },
                    {
                        value: 'company_name',
                        label: window.i18n.__('Nom société'),
                        description: window.i18n.__('Nom de la société.'),
                    },
                    {
                        value: 'company_email',
                        label: window.i18n.__('Email'),
                        description: window.i18n.__('Email de la société.'),
                    },
                    {
                        value: 'company_legal_france_siret',
                        label: window.i18n.__('SIRET'),
                        description: window.i18n.__(
                            'Numéro du Système d’Identification du Répertoire des ETablissements de la société.',
                        ),
                    },
                    {
                        value: 'company_legal_france_siren',
                        label: window.i18n.__('SIREN'),
                        description: window.i18n.__(
                            'Numéro du Système d’Identification du Répertoire des ENtreprises de la société.',
                        ),
                    },
                ],
                multiple: true,
            },
            address: {
                title: window.i18n.__('Critère de comparaison pour les adresses'),
                choices: [
                    {
                        value: 'address_id',
                        label: window.i18n.__('Identifiant adresse'),
                        description: window.i18n.__('Récupéré uniquement depuis un export Sellsy.'),
                    },
                    {
                        value: 'address_name',
                        label: window.i18n.__('Nom adresse'),
                        description: window.i18n.__('Nom associé à l’adresse.'),
                    },
                ],
                multiple: true,
            },
            contact: {
                title: window.i18n.__('Critère de comparaison pour les contacts'),

                choices: [
                    {
                        value: 'contact_id',
                        label: window.i18n.__('Identifiant contact'),
                        description: window.i18n.__('Récupéré uniquement depuis un export Sellsy.'),
                    },
                    {
                        value: 'contact_last_name',
                        label: window.i18n.__('Nom contact'),
                        description: window.i18n.__('Nom de famille du contact.'),
                    },
                    {
                        value: 'contact_first_name',
                        label: window.i18n.__('Prénom contact'),
                        description: window.i18n.__('Prénom du contact.'),
                    },
                    {
                        value: 'contact_email',
                        label: window.i18n.__('Email contact'),
                        description: window.i18n.__('Adresse email du contact.'),
                    },
                ],
                multiple: true,
            },
        },
        parameters: {},
        description: window.i18n.__(
            'Cette section vous permet de déterminer le critère sur lequel nous allons déterminer si un société existe déjà dans vos données Sellsy',
        ),
    },
    globalOptions,
);
export const defaultOptions = {
    identifiers: {
        company: ['company_name'],
        address: ['address_name'],
        contact: ['contact_last_name', 'contact_first_name'],
    },
};
